export default __webpack_public_path__ + "static/post_modular-f649abfc55f739dae123ff468980525f.png";